export default {
      id: "excel-usage",
      viewBox: "0 0 36 44",
      url: __webpack_public_path__ + "sprite-46b249.svg#excel-usage",
      toString: function () {
        return this.url;
      }
    }